module.exports = __webpack_public_path__ + "static/media/Advik,25@2x.bb3a9599.png";